import { ChevronRight, Home } from "lucide-react";
import Link from "next/link";
import { Typography } from "@/components/common/ui/Typography";

export interface BreadcrumbItem {
  label: string;
  href?: string;
  icon?: React.ReactNode;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  if (!items || items.length === 0) return null;

  return (
    <div className="w-full bg-white border-b border-gray-200 px-6 py-3">
      <nav className="flex items-center gap-2" aria-label="Breadcrumb">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <div key={index} className="flex items-center gap-2">
              {item.href && !isLast ? (
                <Link href={item.href}>
                  <Typography variant="body" weight="medium" color="text-navigator-primary" className="hover:text-navigator-primary-dark transition-colors" as="span">
                    {item.label}
                  </Typography>
                </Link>
              ) : (
                <Typography
                  variant="body"
                  weight="semibold"
                  color={isLast ? "default" : "text-navigator-primary"}
                  as="span"
                  aria-current={isLast ? "page" : undefined}
                >
                  {item.label}
                </Typography>
              )}

              {!isLast && <ChevronRight className="w-4 h-4 text-gray-400" />}
            </div>
          );
        })}
      </nav>
    </div>
  );
}
